import { SET_USERS, SET_AUTHORITIES } from ":mutations";

import {
  REQUEST_USERS,
  REQUEST_USER,
  REQUEST_AUTHORITIES,
  ADD_USER,
  UPDATE_USER,
  DELETE_USER
} from ":actions";

import http from ":http";

const state = {
  users: {
    content: []
  },

  authorities: []
};

const mutations = {
  [SET_USERS](state, { users }) {
    state.users = users;
  },

  [SET_AUTHORITIES](state, { authorities }) {
    state.authorities = authorities;
  }
};

const actions = {
  [REQUEST_USERS]({ state, commit }, { page, size }) {
    return http
      .get(`/users`, {
        params: {
          size,
          page: page ? page - 1 : state.users.page - 1
        }
      })
      .then(response =>
        commit(SET_USERS, {
          users: { ...response.data, page: response.data.number + 1 }
        })
      );
  },

  [REQUEST_USER](_, { mailAddress }) {
    return http.get(`/users/${mailAddress}`);
  },

  [REQUEST_AUTHORITIES]({ commit }) {
    return http
      .get("/authorities")
      .then(response =>
        commit(SET_AUTHORITIES, { authorities: response.data })
      );
  },

  [ADD_USER]({ dispatch }, { user }) {
    return http
      .post("/users", { ...user })
      .then(() => dispatch(REQUEST_USERS, {}));
  },

  [UPDATE_USER]({ dispatch }, { mailAddress, user }) {
    return http
      .patch(`/users/${mailAddress}`, { ...user })
      .then(() => dispatch(REQUEST_USERS, {}));
  },

  [DELETE_USER]({ dispatch }, { mailAddress }) {
    return http
      .delete(`/users/${mailAddress}`)
      .then(() => dispatch(REQUEST_USERS, {}));
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
